import React, { useEffect, useState } from 'react'
import AccessControl from '../../components/AccessControl';
import { Button, Col, Popconfirm, Row, Tooltip } from 'antd';
import { Link } from 'react-router-dom';

export default function FuelManualReportLink({ data, authUser }) {
    // const [hasFuelSensorDevice, setHasFuelSensorDevice] = useState(false);
    // const [taggedDeviceAsset, setTaggedDeviceAsset] = useState(null);
    // const [sensorDeviceAsset, setSensorDeviceAsset] = useState(null);
    const [mainAsset, setMainAsset] = useState(null);

    useEffect(() => {
        // console.log(data);
        const { asset, dependentLinkedAsset, dependentLinkHistory } = data || {};
        // console.log(dependentLinkedAsset, dependentLinkHistory);
        setMainAsset(asset);
        // console.log(asset);
        // will use dependentLinkedAsset to find the iot device and fuel sensor (later @todo)

        // if (dependentLinkedAsset && dependentLinkedAsset.length) {
        //     // console.log(dependentLinkedAsset);
        //     const iotDevice = dependentLinkedAsset.find(a => a.assetModel && a.assetModel.isTagDevice && a.tagDeviceId);
        //     if (iotDevice) {
        //         setSensorDeviceAsset(iotDevice.dependents.find(a => a.assetModel && a.assetModel.isFuelSensorDevice));
        //         setTaggedDeviceAsset(iotDevice);
        //         setHasFuelSensorDevice(true)
        //     }
        // }



        // if (dependentLinkHistory && dependentLinkHistory.length) {  
        //     const ix = dependentLinkHistory.findIndex(a => a.subasset && a.subasset.assetModel
        //         && a.subasset.assetModel.isTagDevice && a.subasset.tagDeviceId && a.subasset.parent && a.subasset.parent.toString() === asset._id.toString())
        //     // console.log(ix, dependentLinkHistory[ix]);
        //     if (ix >= 0) {
        //         setTaggedDeviceAsset(dependentLinkHistory[ix].subasset);
        //         setHasFuelSensorDevice(true)
        //     }
        // }
    }, [data]);

    return (<>
        {mainAsset &&
            (<div style={{ marginBottom: '0px' }}>

                {mainAsset && mainAsset.assetModel && mainAsset.assetModel.fuelType &&
                    <AccessControl
                        resource={'Fuel'}
                        permissionNeeded={"report"}
                        roles={authUser ? authUser.roles : []}
                        render={(props) =>
                            <Link target={'_blank'} to={`/fuel/chart/${mainAsset && mainAsset._id}`}>Refuel Chart</Link>
                        } />
                }
            </div >)
        }</>
    )
}
